import { URL_SURVEY_API } from "../utils/constEnvVariables";

export const getHelpDocPdf = function (accessToken, surveyCode, locale, isAuthMethodOkta) {
  let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/nonDeere" : "surveys";
  let requestOptions =
    isAuthMethodOkta !== undefined && !isAuthMethodOkta
      ? {
          method: "GET",
          responseType: "blob",
          mode: "cors",
          cache: "default",
        }
      : {
          method: "GET",
          responseType: "blob",
          mode: "cors",
          cache: "default",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        };

  return fetch(`${URL_SURVEY_API}/${pathParam}/generic/${surveyCode}/helpdoc?locale=${locale}`, requestOptions).then((response) => {
    return response;
  });
};

export const getHelpDocPdfBySurveyId = function (accessToken, surveyId, locale, isAuthMethodOkta) {
  let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/nonDeere" : "surveys";
  let requestOptions =
    isAuthMethodOkta !== undefined && !isAuthMethodOkta
      ? {
          method: "GET",
          responseType: "blob",
          mode: "cors",
          cache: "default",
        }
      : {
          method: "GET",
          responseType: "blob",
          mode: "cors",
          cache: "default",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        };

  return fetch(`${URL_SURVEY_API}/${pathParam}/generic/helpdoc/${surveyId}?locale=${locale}`, requestOptions).then((response) => {
    return response;
  });
};

export const uploadSurveyPartAttachments = function (file, surveyCode, assignmentId, accessToken, isAuthMethodOkta) {
  let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/nonDeere" : "surveys/generic";
  let fd = new FormData();
  fd.append("file", file[0]);
  fd.append("surveyCode", surveyCode);
  fd.append("assignmentId", assignmentId);
  fd.append("fileName", file[0].name);
  const requestOptions =
    isAuthMethodOkta !== undefined && !isAuthMethodOkta
      ? {
          method: "POST",
          headers: {
            Accept: "*/*",
          },
          body: fd,
        }
      : {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            Accept: "*/*",
          },
          body: fd,
        };
  return fetch(`${URL_SURVEY_API}/${pathParam}/attachments/upload`, requestOptions);
};

export const uploadHelpDoc = function (attachmentFiles, surveyCode, templateRevision, accessToken) {
  let fd = new FormData();
  const objFileNames = [];
  if(attachmentFiles){
    attachmentFiles.forEach((att) => {
        fd.append(`file_${att.docName}`, att.file);
        objFileNames.push({ languageCd: att.languageCd, fileName: att.docName });
    });
  }
  fd.append('fileNames', JSON.stringify(objFileNames));
  const requestOptions =
    {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            Accept: "application/json",
          },
          body: fd,
    };
    
  return fetch(`${URL_SURVEY_API}/surveys/uploadHelpDoc/${surveyCode}&${templateRevision}`, requestOptions);
};

export function getSurveyPartAttachmentUrl(surveyCode, assignmentId, filename, accessToken, isAuthMethodOkta){
  let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/nonDeere" : "surveys/generic";
  let requestOptions =
    isAuthMethodOkta !== undefined && !isAuthMethodOkta
      ? {
          method: "GET",
          responseType: "blob",
          mode: "cors",
          cache: "default",
        }
      : {
          method: "GET",
          responseType: "blob",
          mode: "cors",
          cache: "default",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        };


  return fetch(`${URL_SURVEY_API}/${pathParam}/attachment/url/${surveyCode}/${assignmentId}/${filename}`, requestOptions)
      .then(response => {
          return response
      })
};

export async function getPdf(surveyId, campaignId, questionId, accessToken, isAuthMethodOkta){
  let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/nonDeere" : "surveys";
  const requestOptions = isAuthMethodOkta !== undefined && !isAuthMethodOkta ?
  {
      method: 'GET',
      responseType: 'blob',
      mode: "cors",
      cache: "default",

  }:{
      method: 'GET',
      responseType: 'blob',
      mode: "cors",
      cache: "default",
      headers: {
          'Authorization': `Bearer ${accessToken}`,
      }
  }

  const response = await fetch(`${URL_SURVEY_API}/${pathParam}/pdf/${surveyId}&${campaignId}&${questionId}`, requestOptions);
  return response;
}


export const uploadSurveyByPartAttachments = function (file, surveyCode, campaignId, assignmentId, partId, queId, accessToken, isAuthMethodOkta) {
  let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/nonDeere" : "surveys/generic";
  let fd = new FormData();
  fd.append("file", file[0]);
  fd.append("surveyCode", surveyCode);
  fd.append("assignmentId", assignmentId);
  fd.append("campaignId", campaignId);
  fd.append("partId", partId);
  fd.append("questionId", queId);
  fd.append("fileName", file[0].name);
  const requestOptions =
    isAuthMethodOkta !== undefined && !isAuthMethodOkta
      ? {
          method: "POST",
          headers: {
            Accept: "*/*",
          },
          body: fd,
        }
      : {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            Accept: "*/*",
          },
          body: fd,
        };
  return fetch(`${URL_SURVEY_API}/${pathParam}/attachments/parts/upload`, requestOptions);
};

export function getSurveyByPartAttachmentUrl(fileName,surveyCode, campaignId, assignmentId, partId, queId, accessToken, isAuthMethodOkta){
  let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/nonDeere" : "surveys/generic";
  const requestOptions =
    isAuthMethodOkta !== undefined && !isAuthMethodOkta
      ? {
          method: "GET",
          responseType: "blob",
          mode: "cors",
          cache: "default",
          Accept: "*/*"
        }
      : {
          method: "GET",
          responseType: "blob",
          mode: "cors",
          cache: "default",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            Accept: "*/*"
          },
        };

        return fetch(`${URL_SURVEY_API}/${pathParam}/attachment/parts/url/${surveyCode}/${campaignId}/${assignmentId}/${partId}/${queId}/${fileName}`, requestOptions)
        .then(response => {
          return response
        });
    }